import angular = require('angular');
import _ = require('underscore');
import { CommonCampaignsService } from '../../modules/services/commonCampaigns.service';


class DaysOfWeek {
    static $inject = ['commonCampaignsService'];
    days: number;
    daysOfWeek: string;
    constructor(private campaignsService: CommonCampaignsService) { }

    $onChanges(changes: any) {
        this.daysOfWeek = _.isNumber(this.days) ? this.campaignsService.getSelectdaysOfWeek(this.days) : null;
    }
}

angular
    .module('app.retailes.common')
    .component('daysOfWeek', {
        template: require('./days-of-week.html'),
        controller: DaysOfWeek,
        controllerAs: 'vm',
        bindings: {
            days: '<'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/components/days-of-week/days-of-week.component.ts